<template>
    <div class="xiaohua">
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2 class="text-white mt-0">开心一刻</h2>
                    <hr class="divider divider-light" />
                    <transition name="jokes" mode="out-in">
                        <div :key="key" class="text-white-75 mb-4">
                            {{ xiao }}
                        </div>
                    </transition>
                    <input type="button" @click="qiehuan" value="换一个"  class="btn btn-light btn-xl">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import axios from 'axios'
export default {
    name:"jokes",
    data(){
        return{
            xiao:"",
            key:""
        }
    },
    methods:{
        qiehuan(){
            axios.get("https://autumnfish.cn/api/joke/list?num=1").then(
                (a)=>{
                    this.xiao = a.data.jokes[0];
                    this.key = a.data.jokes[0];
                    },(a)=>{console.log(a);}
            )
        }
    },
     beforeCreate(){
        axios.get("https://autumnfish.cn/api/joke/list?num=1").then(
                (a)=>{this.xiao = a.data.jokes[0];
                this.xiao = a.data.jokes[0];
                },(a)=>{console.log(a);}
            )
     }
    
}

</script>

<style scoped>
    .mb-4{
        min-height: 100px;
    }
    .container{
        padding-top: 180px;
    }
    .xiaohua{
        height: 100vh;
        background: linear-gradient(to bottom, rgba(92, 77, 66, 0.6) 0%, rgba(92, 77, 66, 0.6) 100%), url("../assets/Background/background-1.jpg");
        background-position: top left;
        background-repeat: no-repeat;
        background-attachment: scroll;
        background-size: cover;
    }
    .jokes-enter,.jokes-leave-to{
        transform: translateX(20px);
        opacity: 0;
    }
    .jokes-enter-active,.jokes-leave-active{
        transition:all 0.5s ease-in-out;
    }


</style>